function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "Segment_svg__4_a"
}, React.createElement("stop", {
  stopColor: "#4DB1FD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#148CFC",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.313 12c.931 0 1.687.756 1.687 1.688v.624c0 .932-.756 1.688-1.688 1.688H4.688A1.688 1.688 0 013 14.312v-.624C3 12.755 3.756 12 4.688 12h8.625zM11.5 13h-6a.5.5 0 100 1h6a.5.5 0 100-1zm1.813-11C14.244 2 15 2.756 15 3.688v4.624C15 9.245 14.244 10 13.312 10H4.688A1.687 1.687 0 013 8.312V3.689C3 2.756 3.756 2 4.688 2h8.625zM9.5 6h-4a.5.5 0 000 1h4a.5.5 0 000-1zm3-2h-7a.5.5 0 000 1h7a.5.5 0 100-1z",
  transform: "translate(-3 -2)",
  fill: "url(#Segment_svg__4_a)",
  fillRule: "evenodd"
});

var SvgSegment = function SvgSegment(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14"
  }, props), _ref, _ref2);
};

export default SvgSegment;